import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { activateEntrepriseFailure, activateEntrepriseStart, activateEntrepriseSuccess, addEntrepriseFailure, addEntrepriseStart, addEntrepriseSuccess, getEntreprisesFailure, getEntreprisesMiniSuccess, getEntreprisesStart, getEntreprisesSuccess, updateEntrepriseFailure, updateEntrepriseStart, updateEntrepriseSuccess } from "./EntrepriseActions";


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getEntreprises = async(dispatch, pageSize, page, idWilaya, idCommune, nom, email)=>{
    let entrepriseFilter = {wilaya: idWilaya, commune: idCommune, nom: nom, email: email};
    dispatch(getEntreprisesStart());
    try{
        const res = await axiosInstance.post(`/admin/entreprises?pageSize=${pageSize}&page=${page}`,entrepriseFilter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getEntreprisesSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getEntreprisesFailure(err.response.data.message))
        }else{
            dispatch(getEntreprisesFailure("Unkown Error"))
        }
    }
}

export const addEntreprise = async(dispatch, nom, idWilaya, idCommune, tel1, tel2, email, address ,costPromotion, ramassagePromotion, depotPromotion, rc, nif, nis, ai)=>{
    let entreprise = {nom, wilaya: idWilaya, commune: idCommune, tel1, tel2, email, address, costPromotion, ramassagePromotion, depotPromotion, rc, nif, nis, ai};
    dispatch(addEntrepriseStart())
    try{
        const res = await axiosInstance.post(`/admin/entreprises/add`,entreprise,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addEntrepriseSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(addEntrepriseFailure(err.response.data.message))
        }else{
            dispatch(addEntrepriseFailure("Unkown Error"))
        }
    }
}

export const updateEntreprise = async(dispatch, id, nom, idWilaya, idCommune, email, tel1, tel2, address ,costPromotion, ramassagePromotion, depotPromotion, rc, nif, nis, ai)=>{
    let entreprise = {nom, wilaya: idWilaya, commune: idCommune, tel1, tel2, email, address ,costPromotion, ramassagePromotion, depotPromotion, rc, nif, nis, ai};
    dispatch(updateEntrepriseStart())
    try{
        const res = await axiosInstance.put(`/admin/entreprises/update/${id}`,entreprise,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateEntrepriseSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateEntrepriseFailure(err.response.data.message))
        }else{
            dispatch(updateEntrepriseFailure("Unkown Error"))
        }
    }
}

export const ToggleActiveEntreprise = async(dispatch, entrepriseId)=>{
    dispatch(activateEntrepriseStart())
    try{
        const res = await axiosInstance.post(`/admin/entreprises/active`,{id:  entrepriseId},{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(activateEntrepriseSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(activateEntrepriseFailure(err.response.data.message))
        }else{
            dispatch(activateEntrepriseFailure("Unkown Error"))
        }
    }
}

export const getEntreprisesMini = async(dispatch)=>{
    try{
        const res = await axiosInstance.get(`/admin/entreprises`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getEntreprisesMiniSuccess(res.data));
    }catch(err){
        if(err.response){
            console.log(err.response.data.message);
        }else{
            console.log("Unkown Error");
        }
    }
}